<template>
  <div>
    <h3>Organisation > Créer une organisation </h3>
    <br>

    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-stepper v-model="stepper">
      <!-- <v-stepper-header> -->
      <!-- <v-stepper-step step="1" :complete="stepper > 1">Enregistrer une organisation</v-stepper-step> -->
      <!-- 
        <v-divider></v-divider>

        <v-stepper-step step="2" >Informations de localisation</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3" >Les Commités</v-stepper-step> -->
      <!-- </v-stepper-header> -->

      <v-stepper-items class="mt-1">
        <v-form ref="form">
          <v-stepper-content step="1" class="mt-3">
            <v-card flat>
              <v-card-title>
                <h6 class="primary--text">Enregistrer une organisation</h6>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-layout row wrap align-center>
                    <v-flex xs6 sm4>
                      <v-subheader>Année de collecte </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8>
                      <v-select v-model="org.collect_year" :items="years" v-validate="'required'"
                        :error-messages="errors.collect('Année de collecte')" data-vv-name="Année de collecte"
                        label="Année de collecte" clearable solo></v-select>
                    </v-flex>
                    <v-flex xs6 sm4>
                      <v-subheader>Nouvelle OPA?</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8>
                      <v-radio-group v-model="org.is_new_opa" inline>
                        <v-radio label="Non" value="false" color="primary"></v-radio>
                        <v-radio label="Oui" value="true" color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs6 sm4 type="number" v-show="org.is_new_opa == 'false'">
                      <v-subheader>Personne de contact</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field v-model="org.pr_name" label="Personne de contact" v-validate="'required'"
                        :error-messages="errors.collect('Personne de contact organisation')"
                        data-vv-name="Personne de contact organisation" clearable solo>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Contact</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field v-model="org.contact" v-validate="'required'"
                        :error-messages="errors.collect('contact personne')" data-vv-name="contact personne"
                        label="Contact" clearable solo>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Courriel </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field v-model="org.email" v-validate="'required'"
                        :error-messages="errors.collect('Courriel organisation')" data-vv-name="Courriel organisation"
                        label="Courriel de l'organisation" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Total des membres de la coopérative </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field type="number" v-model="org.members_count" v-validate="'required'"
                        :error-messages="errors.collect('Total des membres de la coopérative')"
                        data-vv-name="Total des membres de la coopérative" label="Total des membres de la coopérative"
                        clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Nombre d'hommes dans la coopérative </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field type="number" v-model="org.men_count" v-validate="'required'"
                        :error-messages="errors.collect('Nombre hommes dans la coopérative')"
                        data-vv-name="Nombre hommes dans la coopérative" label="Nombre d'hommes dans la coopérative "
                        clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Nombre de femmes dans la coopérative</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field type="number" v-model="org.women_count" v-validate="'required'"
                        :error-messages="errors.collect('Nombre de femmes dans la coopérative')"
                        data-vv-name="Nombre de femmes dans la coopérative" label="Nombre de femmes dans la coopérative"
                        clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Nombre de jeunes hommes dans la coopérative </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field type="number" v-model="org.young_men_count"
                        label="Nombre de jeunes hommes dans la coopérative" v-validate="'required'"
                        :error-messages="errors.collect('Nombre de jeunes hommes dans la coopérative')"
                        data-vv-name="Nombre de jeunes hommes dans la coopérative" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Nombre de jeunes femmes dans la coopérative</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field type="number" v-model="org.young_women_count"
                        label="Nombre de jeunes femmes dans la coopérative" v-validate="'required'"
                        :error-messages="errors.collect('Nombre de jeunes femmes dans la coopérative')"
                        data-vv-name="Nombre de jeunes femmes dans la coopérative" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Quelles sont les services que vous rendez à vos membres?</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-text-field v-model="org.services_for_members" :rules="nameRules"
                        label="Quelles sont les services que vous rendez à vos membres?" v-validate="'required'"
                        :error-messages="errors.collect('services')" data-vv-name="services" clearable
                        solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'false'">
                      <v-subheader>Quelles sont les filières sur lesquelles l'OPA est-elle positionné</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'false'">
                      <v-select v-model="org.value_chain_id" :items="value_chains" item-text="name" item-value="id"
                        :rules="[v => !!v || 'Filière requise']"
                        label="Quelles sont les filières sur lesquelles l'OPA est-elle positionné" clearable
                        v-validate="'required'" :error-messages="errors.collect('Filière')" data-vv-name="Filière"
                        solo></v-select>
                    </v-flex>
                    <!--<v-flex xs6 sm4 v-show="org.is_new_opa == 'true' || org.is_new_opa !== 'null' && org.is_new_opa !== 'false'">
                      <v-subheader>Pays</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true' || org.is_new_opa !== 'null' && org.is_new_opa !== 'false'">
                      <v-select
                        v-model="org.country_id"
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        item-key="id"
                        :rules="[v => !!v || 'Pays requis']"
                        label="Pays"
                        @input="chooseDepartement()"
                        clearable
                        solo></v-select>
                    </v-flex> -->

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Département</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-select v-model="org.department_id" :items="departments" item-text="name" item-value="id"
                        item-key="id" v-validate="'required'" :error-messages="errors.collect('Département')"
                        data-vv-name="Département" required label="Département" @input="chooseMunicipality()" clearable
                        solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Commune</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-select v-model="org.municipality_id" :items="municipalities" item-text="name" item-value="id"
                        item-key="id" v-validate="'required'" :error-messages="errors.collect('Commune')"
                        data-vv-name="Commune" required label="Commune" @input="chooseDistrict()" clearable
                        solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Arrondissement</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-select v-model="org.district_id" :items="districts" item-text="name" item-value="id"
                        item-key="id" v-validate="'required'" :error-messages="errors.collect('Arrondissement')"
                        data-vv-name="Arrondissement" required label="Arrondissement" @input="chooseTown()" clearable
                        solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Village</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-select v-model="org.town_id" :items="towns" item-text="name" item-value="id" item-key="id"
                        v-validate="'required'" :error-messages="errors.collect('Village')" data-vv-name="Village"
                        required label="Village" clearable solo></v-select>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Adresse/Maison</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-text-field v-model="org.address" :rules="nameRules" v-validate="'required'"
                        :error-messages="errors.collect('Adresse/Maison')" data-vv-name="Adresse/Maison" required
                        label="Adresse/Maison" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Type d'OPA</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-select v-model="org.type" :items="types" v-validate="'required'"
                        :error-messages="errors.collect('Type OPA')" data-vv-name="Type OPA" required label="Type d'OPA"
                        clearable solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4 v-if="org.type == 'Coopérative'">
                      <v-subheader>Forme juridique</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type == 'Coopérative'">
                      <v-select v-model="org.legal_form" :items="legalForms" v-validate="'required'"
                        :error-messages="errors.collect('Forme juridique')" data-vv-name="Forme juridique" required
                        label="Forme juridique" clearable solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4>
                      <v-subheader>Dénomination de l'OPA </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8>
                      <v-text-field v-model="org.name" label="Dénomination de l'OPA" :rules="nameRules"
                        v-validate="'required'" :error-messages="errors.collect('Dénomination')"
                        data-vv-name="Dénomination" required clearable solo></v-text-field>
                    </v-flex>


                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Date de création</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                          <v-text-field :value="eventDateMoment" clearable label="Date de création" readonly v-on="on"
                            prepend-icon="mdi-calendar" solo></v-text-field>
                        </template>

                        <v-date-picker :max="allowedDateStart" v-model="org.creation_date"
                          @input="menu1 = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Personne de contact</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.contact_person" v-validate="'required'"
                        :error-messages="errors.collect('Personne de contact')" data-vv-name="Personne de contact"
                        required label="Personne de contact" clearable solo>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Contact</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.contact" v-validate="'required'"
                        :error-messages="errors.collect('Contact')" data-vv-name="Contact" required label="Contact"
                        clearable solo>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Courriel </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.email" v-validate="'required'"
                        :error-messages="errors.collect('Courriel')" data-vv-name="Courriel" required
                        label="Courriel de l'OPA" clearable solo></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true'">
                      <v-subheader>Mallions</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true'">
                      <v-select v-model="org.maillon_id" :items="maillons" item-text="name" item-value="id" item-key="id"
                        v-validate="'required'" :error-messages="errors.collect('Maillon')" data-vv-name="Maillon"
                        required label="Maillon" clearable solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Total des membres de la coopérative </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.members_count" type="number" v-validate="'required'"
                        :error-messages="errors.collect('Total des membres de la coopérative')"
                        data-vv-name="Total des membres de la coopérative" required
                        label="Total des membres de la coopérative" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Nombre d'hommes dans la coopérative </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.men_count" type="number" v-validate="'required'"
                        :error-messages="errors.collect('Nombre hommes dans la coopérative')"
                        data-vv-name="Nombre hommes dans la coopérative" required
                        label="Nombre d'hommes dans la coopérative" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Nombre de femmes dans la coopérative</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.women_count" type="number" v-validate="'required'"
                        :error-messages="errors.collect('Nombre femmes dans la coopérative')"
                        data-vv-name="Nombre femmes dans la coopérative" required
                        label="Nombre de femmes dans la coopérative" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Nombre de jeunes hommes dans la coopérative </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.young_men_count" type="number" v-validate="'required'"
                        :error-messages="errors.collect('Nombre de jeunes hommes dans la coopérative')"
                        data-vv-name="Nombre de jeunes hommes dans la coopérative" required
                        label="Nombre de jeunes hommes dans la coopérative" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Nombre de jeunes femmes dans la coopérative</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.young_women_count" type="number" v-validate="'required'"
                        :error-messages="errors.collect('Nombre de jeunes femmes dans la coopérative')"
                        data-vv-name="Nombre de jeunes femmes dans la coopérative" required
                        label="Nombre de jeunes femmes dans la coopérative" clearable solo></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Quelles sont les services que vous rendez à vos membres?</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-text-field v-model="org.services_for_members" v-validate="'required'"
                        :error-messages="errors.collect('Courriel')" data-vv-name="Courriel" required :rules="nameRules"
                        label="Quelles sont les services que vous rendez à vos membres?" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.type != null">
                      <v-subheader>Quelles sont les filières sur lesquelles l'OPA est-elle positionné</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.type != null">
                      <v-select v-model="org.value_chain_id" :items="value_chains" item-text="name" item-value="id"
                        v-validate="'required'" :error-messages="errors.collect('filières')" data-vv-name="filières"
                        required clearable label="Quelles sont les filières sur lesquelles l'OPA est-elle positionné"
                        solo></v-select>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true' || org.is_new_opa == 'false' && org.type != null">
                      <v-subheader>L'OPA a t-elle un comité de gestion? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true' || org.is_new_opa == 'false' && org.type != null">
                      <v-radio-group v-model="org.have_management_committee" inline>
                        <v-radio label="Non" value="false" color="primary"></v-radio>
                        <v-radio label="Oui" value="true" color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>


                    <v-flex xs6 sm4 v-show="org.have_management_committee == 'true'">
                      <v-subheader>Nombre de membres dans le comité de gestion </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_management_committee == 'true'">
                      <v-text-field v-model="org.management_members_count" type="number"
                        label="Effectif membres de l'organisation" v-validate="'required'"
                        :error-messages="errors.collect('Effectif membres')" data-vv-name="Effectif membres" required
                        clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_management_committee == 'true'">
                      <v-subheader>Nombre d'hommes membres dans le comité de gestion </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_management_committee == 'true'">
                      <v-text-field v-model="org.management_men_count" type="number"
                        label="Effectif d'hommes membres de l'organisation" v-validate="'required'"
                        :error-messages="errors.collect('Effectif hommes membres')" data-vv-name="Effectif hommes membres"
                        required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_management_committee == 'true'">
                      <v-subheader>Nombre de femmes membres dans le comité de gestion </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_management_committee == 'true'">
                      <v-text-field v-model="org.management_women_count" type="number"
                        label="Effectif de femmes membres de l'organisation" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de femmes membres')"
                        data-vv-name="Effectif de femmes membres" required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_management_committee == 'true'">
                      <v-subheader>Nombre de jeunes hommes membres dans le comité de gestion</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_management_committee == 'true'">
                      <v-text-field v-model="org.management_young_men_count" type="number"
                        label="Effectif de jeunes hommes  membres de l'organisation" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de jeunes hommes')"
                        data-vv-name="Effectif de jeunes hommes" required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_management_committee == 'true'">
                      <v-subheader>Nombre de jeunes femmes membres dans le comité de gestion </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8
                      v-show="org.have_management_committee == 'true' && org.have_management_committee != null">
                      <v-text-field v-model="org.management_young_women_count" type="number"
                        label="Effectif de jeunes femmes membres de l'organisation" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de jeunes femmes')"
                        data-vv-name="Effectif de jeunes femmes" required clearable solo></v-text-field>
                    </v-flex>


                    <v-flex xs6 sm4
                      v-show="org.is_new_opa == 'true' || org.is_new_opa == 'false' && org.is_new_opa != null">
                      <v-subheader>L'OPA a-t-elle un conseil d’administration ? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8
                      v-show="org.is_new_opa == 'true' || org.is_new_opa == 'false' && org.is_new_opa != null">
                      <v-radio-group v-model="org.have_board_of_directors" inline>
                        <v-radio label="Non" value="false" color="primary"></v-radio>
                        <v-radio label="Oui" value="true" color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Effectif total du Conseil d’Administration</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_members_count"
                        label="Effectif total du Conseil d’Administration" v-validate="'required'"
                        :error-messages="errors.collect('Effectif total')" type="number" data-vv-name="Effectif total"
                        required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Nombre d'hommes membres dans le conseil d’administration </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_men_count"
                        label="Effectif d'hommes membres de l'organisation" v-validate="'required'"
                        :error-messages="errors.collect('Nombre homme dans le Conseil')" type="number"
                        data-vv-name="Nombre homme dans le Conseil" required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Nombre de femmes membres dans le conseil d’administration</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_women_count"
                        label="Effectif de femmes membres de le conseil d’administration" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de femmes')" type="number"
                        data-vv-name="Effectif de femmes" required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Nombre de jeunes hommes membres dans le conseil d’administration</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_young_men_count"
                        label="Effectif de jeunes hommes  membres de le conseil d’administration" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de jeunes hommes CA')" type="number"
                        data-vv-name="Effectif de jeunes hommes CA" required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Nombre de jeunes femmes membres dans le conseil d’administration</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_young_women_count"
                        label="Nombre de jeunes femmes membres dans le conseil d’administration" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de jeunes femmes CA')" type="number"
                        data-vv-name="Effectif de jeunes femmes CA" required clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>President de l'administration </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_president" :rules="nameRules"
                        label="President de l'administration" clearable solo></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Sécrétaire de l'administration </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_secretary" :rules="nameRules"
                        label="Sécrétaire de l'administration" clearable solo></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_board_of_directors == 'true'">
                      <v-subheader>Trésorier de l'administration </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm v-show="org.have_board_of_directors == 'true'">
                      <v-text-field v-model="org.administration_treasurer" :rules="nameRules"
                        label="Trésorier de l'organisation" clearable solo></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.is_new_opa == 'true' && org.type != null">
                      <v-subheader>L'OPA a-t-elle un Conseil ou commission de surveillance? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.is_new_opa == 'true' && org.type != null">
                      <v-radio-group v-model="org.have_supervisory_board" inline>
                        <v-radio label="Non" value="false" color="primary"></v-radio>
                        <v-radio label="Oui" value="true" color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_supervisory_board == 'true'">
                      <v-subheader>Nombre de membres dans le commission de surveillance? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_supervisory_board == 'true'">
                      <v-text-field v-model="org.supervisory_members_count"
                        label="Nombre de membres dans le commission de surveillance" v-validate="'required'"
                        :error-messages="errors.collect('Effectif total CS')" type="number"
                        data-vv-name="Effectif total CS" required clearable></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_supervisory_board == 'true'">
                      <v-subheader>Nombre d'hommes membres dans le commission de surveillance? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_supervisory_board == 'true'">
                      <v-text-field v-model="org.supervisory_men_count"
                        label="Nombre d'hommes membres dans le commission de surveillance? " v-validate="'required'"
                        :error-messages="errors.collect('Nombre homme dans le CS')" type="number"
                        data-vv-name="Nombre homme dans le CS" required clearable></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_supervisory_board == 'true'">
                      <v-subheader>Nombre de femmes membres dans le commission de surveillance? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_supervisory_board == 'true'">
                      <v-text-field v-model="org.supervisory_women_count"
                        label="Nombre de femmes membres dans le commission de surveillance?" v-validate="'required'"
                        :error-messages="errors.collect('Effectif de femmes CS')" type="number"
                        data-vv-name="Effectif de femmes CS" required clearable></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_supervisory_board == 'true'">
                      <v-subheader>Nombre de jeunes hommes membres dans le commission de surveillance?</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_supervisory_board == 'true'">
                      <v-text-field v-model="org.supervisory_young_men_count"
                        label="Nombre de jeunes hommes membres dans le commission de surveillance?"
                        v-validate="'required'" :error-messages="errors.collect('Effectif de jeunes hommes CS')"
                        type="number" data-vv-name="Effectif de jeunes hommes CS" required clearable></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_supervisory_board == 'true'">
                      <v-subheader>Nombre de jeunes femmes membres dans le commission de surveillance? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_supervisory_board == 'true'">
                      <v-text-field v-model="org.supervisory_young_women_count"
                        label="Nombre de jeunes femmes membres dans le commission de surveillance?"
                        v-validate="'required'" :error-messages="errors.collect('Effectif de jeunes femmes CS')"
                        type="number" data-vv-name="Effectif de jeunes femmes CS" required clearable></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4
                      v-show="org.is_new_opa == 'true' || org.is_new_opa == 'false' && org.is_new_opa !== 'null'">
                      <v-subheader>L'OPA a-t-elle un Bureau exécutif? </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8
                      v-show="org.is_new_opa == 'true' || org.is_new_opa == 'false' && org.is_new_opa !== 'null'">
                      <v-radio-group v-model="org.have_executive_board" inline>
                        <v-radio label="Non" value="false" color="primary"></v-radio>
                        <v-radio label="Oui" value="true" color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre de membres dans le Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_members_count" label="Effectif membres de l'organisation"
                        clearable solo v-validate="'required'" :error-messages="errors.collect('Effectif total BE')"
                        type="number" data-vv-name="Effectif total BE" required></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre d'hommes membres dans le Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_men_count" label="Effectif d'hommes membres de l'organisation"
                        clearable solo v-validate="'required'" :error-messages="errors.collect('Nombre homme dans le BE')"
                        type="number" data-vv-name="Nombre homme dans le BE" required></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre de femmes membres dans le Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_women_count"
                        label="Effectif de femmes membres de le Bureau exécutif" clearable solo v-validate="'required'"
                        :error-messages="errors.collect('Effectif de femmes BE')" type="number"
                        data-vv-name="Effectif de femmes BE" required></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre de jeunes hommes membres dans le Bureau exécutif</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_young_men_count"
                        label="Effectif de jeunes hommes  membres de le Bureau exécutif" clearable solo
                        v-validate="'required'" :error-messages="errors.collect('Effectif de jeunes hommes BE')"
                        type="number" data-vv-name="Effectif de jeunes hommes BE" required></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre de jeunes femmes membres dans le Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_young_women_count"
                        label="Effectif de jeunes femmes membres de le Bureau exécutif" clearable solo
                        v-validate="'required'" :error-messages="errors.collect('Effectif de jeunes femmes BE')"
                        type="number" data-vv-name="Effectif de jeunes femmes BE" required></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>President du Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_president" :rules="nameRules"
                        label="President du Bureau exécutif" clearable solo v-validate="'required'"
                        :error-messages="errors.collect('President du BE')" data-vv-name="President du BE"
                        required></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Sécrétaire du Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_secretary" :rules="nameRules"
                        label="Sécrétaire du Bureau exécutif" clearable solo v-validate="'required'"
                        :error-messages="errors.collect('Sécrétaire du BE')"
                        data-vv-name="Sécrétaire du BE" required></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Trésorier du Bureau exécutif </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.executive_treasurer" :rules="nameRules"
                        label="Trésorier du Bureau exécutif" clearable solo v-validate="'required'"
                        :error-messages="errors.collect('Trésorier du BE')"
                        data-vv-name="Trésorier du BE" required></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Reconnaissance juridique </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-radio-group v-model="org.legal_recognition" inline>
                        <v-radio label="Non" value="false" color="primary"></v-radio>
                        <v-radio label="Oui" value="true" color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Status </v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-radio-group v-model="org.status" inline>
                        <v-radio label="En cours d'immatriculation" value="En cours d'immatriculation"
                          color="primary"></v-radio>
                        <v-radio label="Immatriculé" value="Immatriculé" color="primary"></v-radio>
                        <v-radio label="Journal officiel RB" value="Journal officiel RB" color="primary"></v-radio>
                        <v-radio label="Régistre digitalisé des OPA" value="Régistre digitalisé des OPA"
                          color="primary"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre de réunions statutaire prévue</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.statutory_meetings_planned" :rules="nameRules"
                        label="Nombre de réunions statutaire prévue" clearable solo></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Nombre de réunions statutaire tenues</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-text-field v-model="org.statutory_meetings_held" :rules="nameRules"
                        label="Nombre de réunions statutaire tenues" clearable solo></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm4 v-show="org.have_executive_board == 'true'">
                      <v-subheader>Avez-vous les documents de gestion suivants</v-subheader>
                    </v-flex>
                    <v-flex xs6 sm8 v-show="org.have_executive_board == 'true'">
                      <v-checkbox v-model="org.register_of_members_document" label="Registre des membres"
                        color="primary"></v-checkbox>
                      <v-checkbox v-model="org.cash_register_document" label="Cahier de caisse"
                        color="primary"></v-checkbox>
                      <v-checkbox v-model="org.pv_register_document" label="Registre des PV" color="primary"></v-checkbox>
                      <v-checkbox v-model="org.pv_booklet_document" label="Cahier de PV" color="primary"></v-checkbox>
                      <v-checkbox v-model="org.visitor_notebook_document" label="Cahier de visite"
                        color="primary"></v-checkbox>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <div class="text-center">
              <v-btn rounded color="primary" :loading="uploading" :disabled="loader" @click="newOrganization()">Enregistrer</v-btn>
            </div>
          </v-stepper-content>

          <!-- <v-stepper-content step="2">
            <v-card flat v-show="org.is_new_opa == 'true'">
              <v-card-title>
               <h6 class="primary--text">Informations de localisation</h6>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-layout row wrap align-center>
                   

                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <div class="text-center mt-1">
              <v-btn color="info" rounded @click.native="stepper = 1">Retour</v-btn>
               <v-btn rounded color="primary" @click.native="nextStep(2)">Enregistrer  et  Continuer</v-btn>
             
            </div>
           </v-stepper-content> -->

          <!-- <v-stepper-content step="3">
            <v-card flat>
              <v-card-title>
               <h6 class="primary--text">Les Commités</h6>
              </v-card-title>

            </v-card>
            <div class="text-center mt-1">
              <v-btn color="info" rounded @click.native="stepper = 3">Retour</v-btn>
               <v-btn rounded color="primary" type="submit">Enregistrer</v-btn>
            </div>
           </v-stepper-content> -->

        </v-form>
      </v-stepper-items>
    </v-stepper>

  </div>
</template>

<script>
import axios from 'axios'
import Permissions from '~/mixins/Permissions';

export default {
  name: 'organizations-new',
  mixins: [Permissions],
  data: () => ({
    org_id: null,
    update_ongoing: false,
    loader: false,
    stepper: 0,
    org: {
      is_new_opa: 'true',
      type: null,
      have_board_of_directors: "false",
      have_executive_board: "false",
      have_management_committee: "false",
      have_supervisory_board: 'false',
      legal_recognition: "false"
    },
    types: ["Coopérative",
      "Association",
      "Groupe d'Intérêt Economique (GIE)",
      "Union Communale",
    ],
    documents: ["Registre des membres",
      "Cahier de caisse",
      "Registre des PV",
      "Cahier de PV",
      "Cahier de visite"
    ],
    legalForms: ["Simplifiée",
      "Coopérative avec CA"
    ],
    years: [2023,
      2024,
      2025,
      2026,
      2027
    ],
    nameRules: [v => !!v || "Nom requis"],

    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',
    errorsDictionnary: {
      stepFields: {
        step0: ['Personne de contact organisation', 'Courriel organisation', 'Total des membres de la coopérative', 'Nombre hommes dans la coopérative', 'Nombre de femmes dans la coopérative', 'Nombre de jeunes hommes dans la coopérative', 'Nombre de jeunes femmes dans la coopérative', 'services', 'Filière'],
        step1: ['Année de collecte', 'Dénomination'],
        step2: ['Département', 'Commune', 'Arrondissement', 'Village', 'Adresse/Maison', 'Type OPA'],
        step3: ['Forme juridique'],
        step4: ['Personne de contact', 'Contact', 'Courriel', 'Total des membres de la coopérative', 'Nombre hommes dans la coopérative', 'Nombre femmes dans la coopérative', 'Nombre de jeunes hommes dans la coopérative', 'Nombre de jeunes femmes dans la coopérative', 'filières'],
        step5: ['Effectif membres', 'Effectif hommes membres', 'Effectif de femmes membres', 'Effectif de jeunes hommes', 'Effectif de jeunes femmes'],
        step6: ['Effectif total', 'Nombre homme dans le Conseil', 'Effectif de femmes', 'Effectif de jeunes hommes CA', 'Effectif de jeunes femmes CA'],
        step7: ['Effectif total CS', 'Nombre homme dans le CS', 'Effectif de femmes CS', 'Effectif de jeunes hommes CS', 'Effectif de jeunes femmes CS'],
        step8: ['Effectif total BE', 'Nombre homme dans le BE', 'Effectif de femmes BE', 'Effectif de jeunes hommes BE', 'Effectif de jeunes femmes BE', 'President du BE', 'Sécrétaire du BE', 'Trésorier du BE'],
      }
    },
    menu1: false,
  }),


  computed: {
    value_chains() { return this.$store.getters.chains; },
    maillons() { return this.$store.getters.maillons; },
    countries() { return this.$store.getters.countries; },
    departments() { return this.$store.getters.getDepartments; },
    municipalities() { return this.$store.getters.getMunicipalities; },
    districts() { return this.$store.getters.getDistricts; },
    towns() { return this.$store.getters.getTowns; },
    eventDateMoment() {
      return this.org.creation_date
        ? this.$moment(this.org.creation_date).format('D MMMM YYYY')
        : ''
    },

    allowedDateStart() {
      return this.$moment(new Date()).format('YYYY-MM-DD')
    },
  },


  created() {
    this.$checkPermission('create organizations')
    this.fetchUtils();
  },

  methods: {
    fetchUtils() {
      this.$store.dispatch("fetchMaillons");
      this.$store.dispatch("fetchChains");
      this.$store.dispatch("loadDepartments");
    },

    chooseDepartement() {
      let pays = this.org.country_id;
      this.$store.dispatch('loadDepartments', pays);
    },

    chooseMunicipality() {
      let departement = this.org.department_id;
      this.$store.dispatch('loadMunicipalities', departement);
    },


    chooseDistrict() {
      let commune = this.org.municipality_id;
      this.$store.dispatch('loadDistricts', commune);
    },

    chooseTown() {
      let arrond = this.org.district_id;
      this.$store.dispatch('loadTowns', arrond);
    },

    async nextStep(step) {
      let suite = await this.completeStep(step);
      if (suite) {
        this.stepper = parseInt(step) + 1;
      }
    },

    async stepCompleted(step) {
      let stepField = this.errorsDictionnary.stepFields['step' + step]
      let validations = []
      for (let index = 0; index < stepField.length; index++) {
        const field = stepField[index];

        validations.push(this.$validator.validate(field))
      }
      const results = Promise.all([
        ...validations
      ]);

      const areValid = (await results).every(isValid => isValid);

      return areValid;
    },

    async newOrganization() {
      let canStep = await this.stepCompleted(1)
      if (!canStep) {
        return
      }
      if (this.org.is_new_opa == 'true') {
        let canStep = await this.stepCompleted(2)
        if (!canStep) {
          return
        }
      }
      if (this.org.is_new_opa == 'false') {
        let canStep = await this.stepCompleted(0)
        if (!canStep) {
          return
        }
      }
      if (this.org.type == 'Coopérative') {
        let canStep = await this.stepCompleted(3)
        if (!canStep) {
          return
        }
        if (this.org.type != null) {
          let canStep = await this.stepCompleted(4)
          if (!canStep) {
            return
          }
        }
        if (this.org.have_management_committee == 'true') {
          let canStep = await this.stepCompleted(5)
          if (!canStep) {
            return
          }
        }
        if (this.org.have_board_of_directors == 'true') {
          let canStep = await this.stepCompleted(6)
          if (!canStep) {
            return
          }
        }
        if (this.org.have_supervisory_board == 'true') {
          let canStep = await this.stepCompleted(7)
          if (!canStep) {
            return
          }
        }
        if (this.org.have_executive_board == 'true') {
          let canStep = await this.stepCompleted(8)
          if (!canStep) {
            return
          }
        }

      }
      this.loader = true,

      this.org.is_new_opa = this.org.is_new_opa == 'true' ? true : false
      this.org.have_management_committee = this.org.have_management_committee == 'true' ? true : false
      this.org.have_board_of_directors = this.org.have_board_of_directors == 'true' ? true : false
      this.org.have_supervisory_board = this.org.have_supervisory_board == 'true' ? true : false
      this.org.have_executive_board = this.org.have_executive_board == 'true' ? true : false
      const uri = '/api/organizations'
      await axios.post(uri, this.org);

      this.$router.push({ name: 'organizations.list', params: { new_org_added: true } })
      // }
    }

  }
};
</script>

<style scoped></style>




// WEBPACK FOOTER //
// resources/assets/js/pages/organizations/create.vue